export const employerOnboardingStepData = {
  setupWorkforce: {
    title: 'Step 1: Add your employees',
    subtitle: 'Choose how to add your team:',
    loading: 'Please wait while we connect your payroll provider...',
    title2: 'Transform commuter mobility for your workforce',
  },
  finchSync: {
    title: 'Step 3: Integrate Worksites',
    subtitle: null,
    loading:
      'Please wait while we integrate your worksites and employees. This may take up to a few minutes...',
    title2: 'Transform commuter mobility for your workforce',
  },
  employerDetails: {
    title: 'Step 4: Company Setup',
    subtitle: null,
    loading: null,
    title2: null,
  },
  csvUpload: {
    title: 'Step 1: Workforce Setup',
    subtitle:
      "Let's get your team onboard! Here's how to manually add your team:",
    loading: 'Please wait while we connect your payroll provider...',
    title2: null,
  },
  stripe: {
    title: 'Step 2: Add Funding Source',
    subtitle:
      "Before we roll out benefits to your team, we need to set up a funding source. But hey, no stress! We'll give you an estimate before anything goes live.",
    loading: null,
    title2: 'Transform commuter mobility for your workforce',
  },
  doneOnboarding: {
    title: "Great job! You're one step closer.",
    subtitle: "Here's what's next:",
    loading: null,
    title2: null,
  },
  inviteAdmins: {
    title: 'Getting Started',
    subtitle: 'Invite the rest of your team to Fleet.',
    title2: 'Learn and improve the commuting patterns of your workforce',
  },
  addWorksites: {
    title: 'Upload Commuter Data',
    subtitle:
      "Before you get started, upload your company's commuter data csv, connect using our HRIS Integration, or add a worksite and invite commuters using a custom sign up link.",
    title2: 'Empower your workforce with the best commute options',
  },
  uploading: {
    title: 'Processing Data...',
    subtitle:
      'Give us a minute to process your data so we can find the best possible programs for your commuters.',
    title2: null,
  },
}

export const extraOnboardingCopy = {
  setupWorkforce: {
    automated: {
      header: 'Integrate your HRIS (Recommended)',
      text: 'Seamlessly connect Fleet with your existing HR system via Finch for automatic updates and easy syncing',
    },
    manual: {
      header: 'Manual Upload',
      text: 'Prefer to do it yourself? No problem! Upload a CSV with your workforce data.',
    },
  },
  addPayment: {
    bankAccount: {
      header: 'Link your Bank Account',
      text: 'Connect Fleet to your bank effortlessly via Stripe.',
    },
  },
  success: {
    welcomeEmail: {
      header: 'Welcome Email',
      text: "Your employees will be greeted with a welcome email. They're going to love this!",
    },
    productTour: {
      header: 'Product Tour',
      text: 'Dive into the product tour to master managing your programs like a pro.',
    },
    enjoy: {
      header: 'Enjoy',
      text: "Sit back and bask in your awesomeness. You've earned it",
    },
    stripeEmail: {
      text: 'Watch for an email from Stripe with easy ACH completion instructions.',
    },
    syncEmployees: {
      text: "We'll pull your employee info from your HRIS (no action needed from you)",
    },
    emailStep: {
      text: "Once done, we'll email you the final quick steps to launch your team's commuter benefits.",
    },
    extra:
      "Got any questions or need a hand? We're always here to help. Here's to happier commuting!",
  },
}
